/* ============================================================
   ORIGINAL RENEGADE — THEME JS
   ============================================================ */

(function () {
  'use strict';

  /* ── MOBILE MENU ── */
  const menuBtn  = document.getElementById('menu-open');
  const menuClose = document.getElementById('menu-close');
  const mobileMenu = document.getElementById('mobile-menu');

  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (menuClose && mobileMenu) {
    menuClose.addEventListener('click', closeMenu);
  }
  function closeMenu() {
    if (mobileMenu) {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /* ── ANNOUNCEMENT BAR PAUSE ON HOVER ── */
  const track = document.querySelector('.announcement-bar__track');
  if (track) {
    track.addEventListener('mouseenter', () => track.classList.add('announcement-bar__track--paused'));
    track.addEventListener('mouseleave', () => track.classList.remove('announcement-bar__track--paused'));
  }

  /* ── COUNTDOWN TIMER ── */
  const countdownEl = document.getElementById('countdown-timer');
  if (countdownEl) {
    const targetDateStr = countdownEl.dataset.target;
    if (targetDateStr) {
      const target = new Date(targetDateStr).getTime();

      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

      function tick() {
        const now  = Date.now();
        const diff = target - now;
        if (diff <= 0) {
          ['days','hours','mins','secs'].forEach(k => {
            const el = document.getElementById('cd-' + k);
            if (el) el.textContent = '00';
          });
          return;
        }
        const days  = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const mins  = Math.floor((diff % 3600000) / 60000);
        const secs  = Math.floor((diff % 60000)   / 1000);

        const dEl = document.getElementById('cd-days');
        const hEl = document.getElementById('cd-hours');
        const mEl = document.getElementById('cd-mins');
        const sEl = document.getElementById('cd-secs');

        if (dEl) dEl.textContent = pad(days);
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(mins);
        if (sEl) sEl.textContent = pad(secs);
      }
      tick();
      setInterval(tick, 1000);
    }
  }

  /* ── TOAST NOTIFICATION ── */
  function showToast(title, sub) {
    let toast = document.querySelector('.toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<div class="toast__title">' + title + '</div>' +
                      (sub ? '<div class="toast__sub">' + sub + '</div>' : '');
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-visible'), 3000);
  }

  /* ── ADD TO CART ── */
  const atcBtn = document.getElementById('add-to-cart');
  if (atcBtn) {
    atcBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = document.getElementById('selected-variant-id');
      const qty = document.getElementById('qty-input');
      if (!variantId || !variantId.value) {
        showToast('Please select a size', '');
        return;
      }
      const body = JSON.stringify({
        items: [{ id: parseInt(variantId.value), quantity: parseInt(qty ? qty.value : 1) }]
      });
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      })
      .then(r => r.json())
      .then(data => {
        if (data.status) {
          showToast('Error', data.description || 'Could not add to cart');
        } else {
          showToast('Added to Cart ✓', data.title);
          updateCartCount();
        }
      })
      .catch(() => showToast('Error', 'Something went wrong'))
      .finally(() => {
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add to Cart';
      });
    });
  }

  /* ── UPDATE CART COUNT ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const countEls = document.querySelectorAll('.site-header__cart-count');
        countEls.forEach(el => {
          el.textContent = data.item_count;
          el.style.display = data.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
  updateCartCount();

  /* ── VARIANT SELECTION ── */
  const variantBtns = document.querySelectorAll('.variant-btn');
  if (variantBtns.length) {
    variantBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        // Deselect siblings in same group
        const group = this.closest('.variant-group');
        if (group) {
          group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('is-active'));
        }
        this.classList.add('is-active');

        // Update selected variant ID if all options are chosen
        const selectedId = document.getElementById('selected-variant-id');
        if (selectedId && this.dataset.variantId) {
          selectedId.value = this.dataset.variantId;
        }
      });
    });
  }

  /* ── QUANTITY CONTROLS ── */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('product-info__qty-btn') ||
        e.target.classList.contains('cart-item__qty-btn')) {
      const btn   = e.target;
      const wrap  = btn.closest('[data-qty-wrap]');
      const input = wrap ? wrap.querySelector('input[type="number"], .product-info__qty-input, .cart-item__qty-val') : null;
      if (!input) return;
      const dir = btn.dataset.dir;
      let val = parseInt(input.value) || 1;
      if (dir === 'up')   val = Math.min(val + 1, 99);
      if (dir === 'down') val = Math.max(val - 1, 1);
      input.value = val;
    }
  });

  /* ── PRODUCT GALLERY THUMBNAILS ── */
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        const newSrc = this.dataset.src;
        if (newSrc) mainImg.src = newSrc;
      });
    });
  }

  /* ── EMAIL FORMS (notify + newsletter) ── */
  document.querySelectorAll('[data-email-form]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const input   = this.querySelector('input[type="email"]');
      const success = this.querySelector('.form-success') ||
                      this.parentElement.querySelector('.form-success');
      if (input && input.value) {
        // In Shopify, use the /contact form action — here we just show success state
        if (success) success.classList.add('is-visible');
        input.value = '';
        showToast('You\'re in! 🔥', 'Check your inbox for your 10% off code');
      }
    });
  });

  /* ── CART ITEM REMOVE ── */
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(() => window.location.reload())
      .catch(console.error);
    });
  });

})();


/* ============================================================
   ADDONS: Sticky ATC · Size Modal · Bundle Builder
   ============================================================ */

/* ── STICKY ATC ── */
(function initStickyATC() {
  const stickyBar = document.getElementById('sticky-atc');
  if (!stickyBar) return;

  const stickyBtn = stickyBar.querySelector('.sticky-atc__btn');

  // Sync variant selection from main page to sticky bar
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('sticky-atc__variant-btn')) {
      const bar = e.target.closest('.sticky-atc');
      bar.querySelectorAll('.sticky-atc__variant-btn').forEach(b => b.classList.remove('is-active'));
      e.target.classList.add('is-active');

      // Mirror to main page variant
      const val = e.target.dataset.value;
      const mainBtn = document.querySelector(`.variant-btn[data-value="${val}"]`);
      if (mainBtn) mainBtn.click();
    }
  });

  // Mirror main variant selection to sticky bar
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const val = this.dataset.value;
      const stickyMirror = stickyBar.querySelector(`.sticky-atc__variant-btn[data-value="${val}"]`);
      if (stickyMirror) {
        stickyBar.querySelectorAll('.sticky-atc__variant-btn').forEach(b => b.classList.remove('is-active'));
        stickyMirror.classList.add('is-active');
      }
    });
  });

  // Sticky ATC button click
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      const variantId = document.getElementById('selected-variant-id');
      if (!variantId || !variantId.value) {
        window.showToast && showToast('Select a size first', '');
        return;
      }
      stickyBtn.disabled = true;
      stickyBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId.value), quantity: 1 }] })
      })
      .then(r => r.json())
      .then(data => {
        if (!data.status) {
          stickyBtn.textContent = 'Added ✓';
          updateCartCount();
          setTimeout(() => { stickyBtn.textContent = 'Add to Cart'; stickyBtn.disabled = false; }, 1800);
        } else {
          stickyBtn.textContent = 'Error';
          stickyBtn.disabled = false;
        }
      })
      .catch(() => { stickyBtn.textContent = 'Error'; stickyBtn.disabled = false; });
    });
  }
})();

/* ── SIZE GUIDE MODAL ── */
(function initSizeModal() {
  const trigger  = document.querySelector('.size-modal-trigger');
  const backdrop = document.getElementById('size-modal');
  if (!trigger || !backdrop) return;

  function openModal()  { backdrop.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { backdrop.classList.remove('is-open'); document.body.style.overflow = ''; }

  trigger.addEventListener('click', openModal);
  backdrop.addEventListener('click', function(e) { if (e.target === backdrop) closeModal(); });
  backdrop.querySelector('.modal-box__close').addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

  // Size guide tabs
  backdrop.querySelectorAll('.size-tab').forEach(tab => {
    tab.addEventListener('click', function() {
      backdrop.querySelectorAll('.size-tab, .size-panel').forEach(el => el.classList.remove('is-active'));
      this.classList.add('is-active');
      const panel = backdrop.querySelector('.size-panel[data-panel="' + this.dataset.tab + '"]');
      if (panel) panel.classList.add('is-active');
    });
  });
})();

/* ── BUNDLE BUILDER ── */
(function initBundleBuilder() {
  const builder = document.getElementById('bundle-builder');
  if (!builder) return;

  const TIERS = { 1: 0, 2: 10, 3: 15 };

  function formatMoney(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function getState() {
    const items = [];
    builder.querySelectorAll('.bundle-item').forEach(row => {
      const checkbox = row.querySelector('.bundle-checkbox');
      const isChecked = checkbox.classList.contains('is-checked') ||
                        checkbox.classList.contains('is-locked');
      if (isChecked) {
        const price = parseInt(row.dataset.price, 10) || 0;
        const variantId = parseInt(row.dataset.variantId, 10);
        const select = row.querySelector('.bundle-item__variant-select');
        const selectedVariantId = select ? parseInt(select.value, 10) : variantId;
        items.push({ price, variantId: selectedVariantId });
      }
    });
    return items;
  }

  function updateUI() {
    const items    = getState();
    const count    = items.length;
    const discount = TIERS[Math.min(count, 3)] || 0;
    const total    = items.reduce((s, i) => s + i.price, 0);
    const savings  = Math.round(total * discount / 100);
    const nowTotal = total - savings;

    // Tier badges
    builder.querySelectorAll('.bundle-tier').forEach(t => {
      t.classList.toggle('is-active', parseInt(t.dataset.items) === count);
    });

    // Price rows
    const origEl     = builder.querySelector('.bundle-orig');
    const discEl     = builder.querySelector('.bundle-disc');
    const discRowEl  = builder.querySelector('.bundle-disc-row');
    const totalEl    = builder.querySelector('.bundle-total');
    const savingsEl  = builder.querySelector('.savings-badge');
    const ctaEl      = builder.querySelector('.bundle-cta');
    const nudgeEl    = builder.querySelector('.bundle-nudge');

    if (origEl)     origEl.textContent     = formatMoney(total);
    if (discEl)     discEl.textContent     = discount > 0 ? '−' + formatMoney(savings) : '—';
    if (discRowEl)  discRowEl.style.opacity = discount > 0 ? '1' : '0.3';
    if (totalEl)    totalEl.textContent    = formatMoney(nowTotal);
    if (savingsEl) {
      savingsEl.textContent = discount > 0 ? 'Save ' + discount + '%' : '';
      savingsEl.style.display = discount > 0 ? 'inline-block' : 'none';
    }

    if (ctaEl) {
      ctaEl.disabled = count < 2;
      ctaEl.textContent = count < 2
        ? 'Add 1 More Item to Bundle'
        : 'Add Bundle to Cart — ' + formatMoney(nowTotal);
    }

    // Nudge text
    if (nudgeEl) {
      if (count < 2) {
        nudgeEl.innerHTML = 'Pick <strong>2 items</strong> for 10% off · <strong>3 items</strong> for 15% off';
      } else if (count === 2) {
        const extra = Math.round((items.reduce((s,i)=>s+i.price,0)) * 0.05);
        nudgeEl.innerHTML = 'Add 1 more item and save an extra <strong>' + formatMoney(extra) + '</strong> (15% off)';
      } else {
        nudgeEl.innerHTML = '🔥 Maximum discount applied!';
      }
    }
  }

  // Item click handler
  builder.querySelectorAll('.bundle-item:not(.is-current)').forEach(row => {
    row.addEventListener('click', function(e) {
      // Don't toggle if clicking the variant select
      if (e.target.tagName === 'SELECT') return;
      const checkbox = this.querySelector('.bundle-checkbox');
      checkbox.classList.toggle('is-checked');
      updateUI();
    });
  });

  // Variant select change (don't toggle item)
  builder.querySelectorAll('.bundle-item__variant-select').forEach(sel => {
    sel.addEventListener('change', function(e) {
      e.stopPropagation();
      const row = this.closest('.bundle-item');
      // Update variantId on the row
      row.dataset.variantId = this.value;
      updateUI();
    });
  });

  // Add bundle to cart
  const ctaBtn = builder.querySelector('.bundle-cta');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const items = getState();
      if (items.length < 2) return;

      ctaBtn.disabled = true;
      ctaBtn.textContent = 'Adding…';

      const count    = items.length;
      const discount = TIERS[Math.min(count, 3)] || 0;
      const code     = 'BUNDLE' + discount;

      const cartItems = items.map(i => ({ id: i.variantId, quantity: 1 }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems })
      })
      .then(r => r.json())
      .then(data => {
        if (data.status) throw new Error(data.description);
        // Redirect to checkout with discount code
        window.location.href = '/checkout?discount=' + code;
      })
      .catch(err => {
        ctaBtn.disabled = false;
        ctaBtn.textContent = 'Error — try again';
        console.error(err);
      });
    });
  }

  // Initialise
  updateUI();
})();


/* ── PREDICTIVE SEARCH DROPDOWN ── */
(function initSearch() {
  const toggle   = document.getElementById('search-toggle');
  const overlay  = document.getElementById('search-overlay');
  const backdrop = document.getElementById('search-backdrop');
  const input    = document.getElementById('search-input');
  const closeBtn = document.getElementById('search-close');
  const resultsEl = document.getElementById('search-results');

  if (!toggle || !overlay || !input) return;

  let debounceTimer = null;
  let lastQuery = '';

  function openSearch() {
    overlay.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 80);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    resultsEl.innerHTML = '';
    lastQuery = '';
  }

  toggle.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function renderResults(products, query) {
    if (!products || products.length === 0) {
      resultsEl.innerHTML =
        '<p class="search-overlay__empty">No results for "' + query + '"</p>';
      return;
    }

    let html = '<p class="search-overlay__status">' + products.length + ' result' +
      (products.length !== 1 ? 's' : '') + ' for "' + query + '"</p>';
    html += '<div class="search-results-grid">';

    products.forEach(function(p) {
      const imgSrc = p.featured_image ? p.featured_image.url : '';
      const price  = p.price ? formatMoney(p.price) : '';
      html += '<a href="' + p.url + '" class="search-result-item">';
      if (imgSrc) {
        html += '<div class="search-result-item__img"><img src="' + imgSrc +
          '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></div>';
      } else {
        html += '<div class="search-result-item__img" style="background:var(--c-bg-2);"></div>';
      }
      html += '<div class="search-result-item__info">';
      html += '<p class="search-result-item__title">' + (p.title || '') + '</p>';
      if (price) html += '<p class="search-result-item__price">' + price + '</p>';
      html += '</div></a>';
    });

    html += '</div>';
    html += '<a href="/search?q=' + encodeURIComponent(query) +
      '" class="search-overlay__view-all">View all results →</a>';
    resultsEl.innerHTML = html;
  }

  function doSearch(query) {
    if (!query || query.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }
    if (query === lastQuery) return;
    lastQuery = query;

    resultsEl.innerHTML = '<p class="search-overlay__status">Searching…</p>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,body')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        const products = (data.resources && data.resources.results &&
          data.resources.results.products) || [];
        renderResults(products, query);
      })
      .catch(function() {
        resultsEl.innerHTML = '<p class="search-overlay__empty">Something went wrong</p>';
      });
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    const q = this.value.trim();
    debounceTimer = setTimeout(function() { doSearch(q); }, 280);
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && this.value.trim()) {
      window.location.href = '/search?q=' + encodeURIComponent(this.value.trim());
    }
  });
})();

/* ── QUICK ADD (collection cards) ── */
function quickAdd(variantId, btn) {
  btn.textContent = '...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (!data.status) {
      btn.textContent = 'Added ✓';
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        document.querySelectorAll('.site-header__cart-count').forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = 'flex';
        });
      });
      setTimeout(function() { btn.textContent = 'Quick Add'; btn.disabled = false; }, 1800);
    } else {
      btn.textContent = 'Error';
      btn.disabled = false;
    }
  })
  .catch(function() { btn.textContent = 'Error'; btn.disabled = false; });
}

/* delegated listener — works for all cards rendered on page */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.js-quick-add');
  if (!btn) return;
  e.preventDefault();
  var variantId = parseInt(btn.dataset.variantId, 10);
  if (variantId) quickAdd(variantId, btn);
});

/* ── CONTACT FORM HONEYPOT ── */
(function() {
  var form = document.getElementById('ContactForm');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    var trap = form.querySelector('.contact-trap');
    if (trap && trap.value !== '') {
      e.preventDefault();
    }
  });
})();
